import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ListIcon, PlusIcon, SearchIcon, SlidersIcon, CalendarIcon, TagIcon, CheckCircleIcon, XCircleIcon, ClockIcon, FileTextIcon, DownloadIcon, BarChart2Icon, UsersIcon, BuildingIcon, UserIcon, StarIcon, ArrowUpDownIcon, BellIcon, MoreHorizontalIcon, InfoIcon, FilterIcon, ChevronDownIcon, MoveUpRightIcon, BookmarkIcon, EyeIcon, LayoutGridIcon, TableIcon, KanbanIcon, ArrowRightIcon, TrendingUpIcon, TrendingDownIcon, DollarSignIcon, RefreshCwIcon, SaveIcon, SunIcon, MoonIcon, CircleIcon, XIcon, GaugeIcon, FolderIcon, MailIcon, PhoneIcon, SendIcon, HeartIcon, BookOpenIcon, AlarmClockIcon, ShieldIcon, ShoppingCartIcon, PaletteIcon, ZapIcon, CheckIcon, PieChartIcon, BarChart4Icon, LayoutDashboardIcon, ChevronRightIcon, ArrowDownIcon, ArrowUpIcon, SlidersHorizontalIcon, SettingsIcon, ClipboardIcon, HelpCircleIcon, PencilIcon, FileIcon, PrinterIcon, ExternalLinkIcon, AlertCircleIcon, ThumbsUpIcon, ThumbsDownIcon, LightbulbIcon, AwardIcon, GlobeIcon, MapPinIcon, UsersIcon as TeamIcon } from 'lucide-react';
import { QuoteScoreModal } from '../components/quotes/QuoteScoreModal';
import { BusinessUnitUserModal } from '../components/quotes/BusinessUnitUserModal';
// Business Unit Users data
const businessUnitUsers = [{
  id: 1,
  name: 'John Smith',
  email: 'john.smith@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco AMERICA',
  regions: ['North America', 'Latin America'],
  countries: ['USA', 'Canada', 'Mexico', 'Brazil'],
  dealers: ['American Irrigation Co.', 'Canadian Farm Supply', 'Mexico Agrícola']
}, {
  id: 2,
  name: 'Maria Rodriguez',
  email: 'maria.rodriguez@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco EUROPE',
  regions: ['Western Europe', 'Eastern Europe'],
  countries: ['Spain', 'France', 'Italy', 'Germany', 'Poland'],
  dealers: ['European Irrigation Systems', 'Spanish Agro', 'French Farm Tech']
}, {
  id: 3,
  name: 'Sarah Johnson',
  email: 'sarah.johnson@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco ANZ',
  regions: ['Australia', 'New Zealand', 'Pacific Islands'],
  countries: ['Australia', 'New Zealand', 'Fiji'],
  dealers: ['Australian Farm Equipment', 'NZ Irrigation Ltd', 'Pacific Agro']
}, {
  id: 4,
  name: 'Michael Brown',
  email: 'michael.brown@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco AFRICA',
  regions: ['Southern Africa', 'Eastern Africa', 'Western Africa'],
  countries: ['South Africa', 'Kenya', 'Nigeria', 'Egypt'],
  dealers: ['African Irrigation Solutions', 'Kenya Farm Tech', 'Nigeria Agro']
}, {
  id: 5,
  name: 'Wei Zhang',
  email: 'wei.zhang@aisco.com',
  role: 'Regional Manager',
  businessUnit: 'Aisco ASIA',
  regions: ['East Asia', 'Southeast Asia', 'South Asia'],
  countries: ['China', 'Japan', 'India', 'Thailand', 'Vietnam'],
  dealers: ['China Irrigation Systems', 'Japan Agro Tech', 'India Farm Solutions']
}];
export function QuotesPage({
  onNewQuote,
  onViewQuote,
  onToggleSidebar
}) {
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('list'); // 'list', 'grid', 'kanban'
  const [quickFilterActive, setQuickFilterActive] = useState('all');
  const [dateRange, setDateRange] = useState('all');
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const [favoriteQuotes, setFavoriteQuotes] = useState([]);
  const [showSummaryCards, setShowSummaryCards] = useState(true);
  const [sortOption, setSortOption] = useState('date');
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [selectedScore, setSelectedScore] = useState(null);
  const [selectedBusinessUnitUser, setSelectedBusinessUnitUser] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    status: 'all',
    businessUnitUser: null,
    quoteType: 'all',
    dateRange: 'all',
    region: 'all',
    country: 'all'
  });
  const [notifications, setNotifications] = useState([{
    id: 1,
    title: 'Quote #QT-5872 is expiring soon',
    description: 'The quote will expire in 3 days',
    time: '2 hours ago',
    read: false,
    type: 'warning'
  }, {
    id: 2,
    title: 'Quote #QT-5869 was approved',
    description: 'Quote was approved by Sarah Johnson',
    time: 'Yesterday',
    read: false,
    type: 'success'
  }, {
    id: 3,
    title: 'New quote template available',
    description: 'Check out the new Pivot System template',
    time: '2 days ago',
    read: true,
    type: 'info'
  }]);
  // Toggle filter panel and close main sidebar when opening
  const toggleFilterPanel = () => {
    const newState = !showFilterPanel;
    setShowFilterPanel(newState);
    // If opening the filter panel, close the main sidebar
    if (newState && onToggleSidebar) {
      onToggleSidebar(true); // Pass true to indicate we want to collapse the sidebar
    }
  };
  // Lista de cotizaciones para usar en ambas vistas
  const quotesList = [{
    id: 'QT-5875',
    title: '8" Valley Pivot System with Corner Arm',
    customer: 'John Doe',
    company: 'Farmland Enterprises',
    date: '3 days ago',
    expiresIn: '27 days',
    status: 'active',
    amount: '$24,599.00',
    tags: ['Pivot', 'Corner'],
    score: 92,
    businessUnitUser: 'John Smith',
    region: 'North America',
    country: 'USA'
  }, {
    id: 'QT-5874',
    title: 'Linear System L200 with Generator',
    customer: 'Sarah Johnson',
    company: 'Green Valley Farms',
    date: '4 days ago',
    expiresIn: '25 days',
    status: 'active',
    amount: '$31,850.00',
    tags: ['Linear'],
    score: 87,
    businessUnitUser: 'John Smith',
    region: 'North America',
    country: 'Canada'
  }, {
    id: 'QT-5873',
    title: 'Replacement Parts Package - Valley',
    customer: 'Michael Smith',
    company: 'Sunset Agriculture',
    date: '5 days ago',
    expiresIn: '20 days',
    status: 'pending',
    amount: '$5,420.00',
    tags: ['Parts', 'Service'],
    score: 64,
    businessUnitUser: 'Maria Rodriguez',
    region: 'Western Europe',
    country: 'Spain'
  }, {
    id: 'QT-5872',
    title: '10" Center Pivot System',
    customer: 'Robert Brown',
    company: 'Harvest Fields Inc.',
    date: '1 week ago',
    expiresIn: '3 days',
    status: 'expiring',
    amount: '$42,780.00',
    tags: ['Pivot'],
    score: 78,
    businessUnitUser: 'Maria Rodriguez',
    region: 'Western Europe',
    country: 'France'
  }, {
    id: 'QT-5871',
    title: 'Sprinkler Package Upgrade',
    customer: 'Emma Davis',
    company: 'Davis Family Farms',
    date: '1 week ago',
    expiresIn: '18 days',
    status: 'active',
    amount: '$8,350.00',
    tags: ['Sprinkler', 'Accessories'],
    score: 81,
    businessUnitUser: 'Sarah Johnson',
    region: 'Australia',
    country: 'Australia'
  }, {
    id: 'QT-5870',
    title: 'Warranty Extension - 5 Years',
    customer: 'James Wilson',
    company: 'Wilson Agro Ltd.',
    date: '2 weeks ago',
    expiresIn: '10 days',
    status: 'pending',
    amount: '$3,200.00',
    tags: ['Warranty', 'Service'],
    score: 59,
    businessUnitUser: 'Sarah Johnson',
    region: 'New Zealand',
    country: 'New Zealand'
  }, {
    id: 'QT-5869',
    title: 'Complete Irrigation Solution',
    customer: 'Jennifer Miller',
    company: 'Miller Farming Co.',
    date: '2 weeks ago',
    expiresIn: 'Approved',
    status: 'approved',
    amount: '$78,500.00',
    tags: ['Pivot', 'Linear', 'Accessories'],
    score: 95,
    businessUnitUser: 'Michael Brown',
    region: 'Southern Africa',
    country: 'South Africa'
  }, {
    id: 'QT-5868',
    title: 'Remote Control System Upgrade',
    customer: 'Daniel Taylor',
    company: 'Taylor Irrigation Services',
    date: '3 weeks ago',
    expiresIn: 'Expired',
    status: 'expired',
    amount: '$12,450.00',
    tags: ['Accessories', 'Service'],
    score: 42,
    businessUnitUser: 'Wei Zhang',
    region: 'East Asia',
    country: 'China'
  }];
  // Count active filters
  const activeFilterCount = Object.values(appliedFilters).filter(value => value !== 'all' && value !== null && value !== undefined).length;
  // Initialize tags from quotes
  useEffect(() => {
    setTags([{
      id: 1,
      name: 'Pivot',
      color: 'blue'
    }, {
      id: 2,
      name: 'Linear',
      color: 'green'
    }, {
      id: 3,
      name: 'Sprinkler',
      color: 'purple'
    }, {
      id: 4,
      name: 'Accessories',
      color: 'amber'
    }, {
      id: 5,
      name: 'Parts',
      color: 'rose'
    }, {
      id: 6,
      name: 'Service',
      color: 'teal'
    }, {
      id: 7,
      name: 'Warranty',
      color: 'indigo'
    }, {
      id: 8,
      name: 'Corner',
      color: 'blue'
    }]);
  }, []);
  // Handle search input change
  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };
  // Toggle favorite status for a quote
  const toggleFavorite = quoteId => {
    if (favoriteQuotes.includes(quoteId)) {
      setFavoriteQuotes(favoriteQuotes.filter(id => id !== quoteId));
    } else {
      setFavoriteQuotes([...favoriteQuotes, quoteId]);
    }
  };
  // Mark all notifications as read
  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({
      ...n,
      read: true
    })));
  };
  // Apply a filter
  const applyFilter = (filterType, value) => {
    setAppliedFilters({
      ...appliedFilters,
      [filterType]: value
    });
    // If selecting a business unit user, find the user details
    if (filterType === 'businessUnitUser' && value !== 'all') {
      const user = businessUnitUsers.find(u => u.name === value);
      setSelectedBusinessUnitUser(user);
    } else if (filterType === 'businessUnitUser' && value === 'all') {
      setSelectedBusinessUnitUser(null);
    }
  };
  // Remove a specific filter
  const removeFilter = filterType => {
    const newFilters = {
      ...appliedFilters
    };
    newFilters[filterType] = filterType === 'businessUnitUser' ? null : 'all';
    setAppliedFilters(newFilters);
    if (filterType === 'businessUnitUser') {
      setSelectedBusinessUnitUser(null);
    }
  };
  // Reset all filters
  const resetAllFilters = () => {
    setAppliedFilters({
      status: 'all',
      businessUnitUser: null,
      quoteType: 'all',
      dateRange: 'all',
      region: 'all',
      country: 'all'
    });
    setSelectedBusinessUnitUser(null);
  };
  // Open user details modal
  const openUserModal = () => {
    if (selectedBusinessUnitUser) {
      setShowUserModal(true);
    }
  };
  // Get color for tag
  const getTagColor = color => {
    const colors = {
      blue: {
        bg: 'bg-blue-100 dark:bg-blue-900/40',
        text: 'text-blue-800 dark:text-blue-300',
        border: 'border-blue-200 dark:border-blue-800'
      },
      green: {
        bg: 'bg-green-100 dark:bg-green-900/40',
        text: 'text-green-800 dark:text-green-300',
        border: 'border-green-200 dark:border-green-800'
      },
      purple: {
        bg: 'bg-purple-100 dark:bg-purple-900/40',
        text: 'text-purple-800 dark:text-purple-300',
        border: 'border-purple-200 dark:border-purple-800'
      },
      amber: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        border: 'border-amber-200 dark:border-amber-800'
      },
      rose: {
        bg: 'bg-rose-100 dark:bg-rose-900/40',
        text: 'text-rose-800 dark:text-rose-300',
        border: 'border-rose-200 dark:border-rose-800'
      },
      teal: {
        bg: 'bg-teal-100 dark:bg-teal-900/40',
        text: 'text-teal-800 dark:text-teal-300',
        border: 'border-teal-200 dark:border-teal-800'
      },
      indigo: {
        bg: 'bg-indigo-100 dark:bg-indigo-900/40',
        text: 'text-indigo-800 dark:text-indigo-300',
        border: 'border-indigo-200 dark:border-indigo-800'
      },
      gray: {
        bg: 'bg-gray-100 dark:bg-gray-900/40',
        text: 'text-gray-800 dark:text-gray-300',
        border: 'border-gray-200 dark:border-gray-800'
      }
    };
    return colors[color] || colors.gray;
  };
  // Get status badge style
  const getStatusBadge = status => {
    const styles = {
      active: {
        bg: 'bg-green-100 dark:bg-green-900/40',
        text: 'text-green-800 dark:text-green-300',
        icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-9912" />
      },
      pending: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        icon: <ClockIcon size={14} className="mr-1" data-id="element-9913" />
      },
      expired: {
        bg: 'bg-red-100 dark:bg-red-900/40',
        text: 'text-red-800 dark:text-red-300',
        icon: <XCircleIcon size={14} className="mr-1" data-id="element-9914" />
      },
      expiring: {
        bg: 'bg-amber-100 dark:bg-amber-900/40',
        text: 'text-amber-800 dark:text-amber-300',
        icon: <ClockIcon size={14} className="mr-1" data-id="element-9915" />
      },
      draft: {
        bg: 'bg-gray-100 dark:bg-gray-900/40',
        text: 'text-gray-800 dark:text-gray-300',
        icon: <FileTextIcon size={14} className="mr-1" data-id="element-9916" />
      },
      approved: {
        bg: 'bg-blue-100 dark:bg-blue-900/40',
        text: 'text-blue-800 dark:text-blue-300',
        icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-9917" />
      },
      won: {
        bg: 'bg-blue-100 dark:bg-blue-900/40',
        text: 'text-blue-800 dark:text-blue-300',
        icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-9918" />
      },
      lost: {
        bg: 'bg-gray-100 dark:bg-gray-900/40',
        text: 'text-gray-800 dark:text-gray-300',
        icon: <XCircleIcon size={14} className="mr-1" data-id="element-9919" />
      }
    };
    return styles[status] || styles.pending;
  };
  // Get score color
  const getScoreColor = score => {
    if (score >= 90) return 'text-green-500';
    if (score >= 70) return 'text-blue-500';
    if (score >= 50) return 'text-amber-500';
    return 'text-red-500';
  };
  // Get score background color
  const getScoreBgColor = score => {
    if (score >= 90) return 'bg-green-100 dark:bg-green-900/30';
    if (score >= 70) return 'bg-blue-100 dark:bg-blue-900/30';
    if (score >= 50) return 'bg-amber-100 dark:bg-amber-900/30';
    return 'bg-red-100 dark:bg-red-900/30';
  };
  // Open score modal
  const openScoreModal = (quoteId, event) => {
    if (event) {
      event.stopPropagation();
    }
    const selectedQuote = quotesList.find(q => q.id === quoteId);
    setSelectedScore(quoteId);
    setShowScoreModal(true);
  };
  // Filter quotes based on quick filter selection and applied filters
  const getFilteredQuotes = () => {
    let filtered = quotesList;
    // Apply quick filters
    if (quickFilterActive === 'my-quotes') {
      filtered = filtered.filter(q => q.quotedBy === 'Daniel Alejandro');
    } else if (quickFilterActive === 'dealer-quotes') {
      filtered = filtered.filter(q => q.company && q.company.includes('Ltd'));
    } else if (quickFilterActive === 'expiring-soon') {
      filtered = filtered.filter(q => q.status === 'expiring');
    } else if (quickFilterActive === 'expired') {
      filtered = filtered.filter(q => q.status === 'expired');
    } else if (quickFilterActive === 'won-lost') {
      filtered = filtered.filter(q => q.status === 'approved' || q.status === 'lost');
    }
    // Apply advanced filters
    if (appliedFilters.status !== 'all') {
      filtered = filtered.filter(q => q.status === appliedFilters.status);
    }
    if (appliedFilters.businessUnitUser) {
      filtered = filtered.filter(q => q.businessUnitUser === appliedFilters.businessUnitUser);
    }
    if (appliedFilters.quoteType !== 'all') {
      filtered = filtered.filter(q => q.tags.includes(appliedFilters.quoteType));
    }
    if (appliedFilters.region !== 'all') {
      filtered = filtered.filter(q => q.region === appliedFilters.region);
    }
    if (appliedFilters.country !== 'all') {
      filtered = filtered.filter(q => q.country === appliedFilters.country);
    }
    // Apply search query
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(q => q.id.toLowerCase().includes(query) || q.title.toLowerCase().includes(query) || q.customer.toLowerCase().includes(query) || q.company.toLowerCase().includes(query));
    }
    return filtered;
  };
  const filteredQuotes = getFilteredQuotes();
  // Statistics for summary cards
  const quoteStats = {
    total: quotesList.length,
    active: quotesList.filter(q => q.status === 'active').length,
    pending: quotesList.filter(q => q.status === 'pending').length,
    expiring: quotesList.filter(q => q.status === 'expiring').length,
    expired: quotesList.filter(q => q.status === 'expired').length,
    approved: quotesList.filter(q => q.status === 'approved').length,
    totalValue: quotesList.reduce((sum, quote) => sum + parseFloat(quote.amount.replace(/[^0-9.-]+/g, '')), 0)
  };
  return <div className="flex flex-col h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950" data-id="element-9920">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-9921">
        <div className="absolute top-[10%] left-[5%] w-64 h-64 bg-blue-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9922"></div>
        <div className="absolute top-[40%] right-[10%] w-72 h-72 bg-purple-600 rounded-full mix-blend-multiply filter blur-[80px] opacity-20" data-id="element-9923"></div>
        <div className="absolute bottom-[10%] left-[25%] w-80 h-80 bg-teal-600 rounded-full mix-blend-multiply filter blur-[100px] opacity-20" data-id="element-9924"></div>
      </div>
      {/* Header */}
      <div className="bg-white/5 backdrop-blur-sm border-b border-white/10 px-6 py-4 relative z-10" data-id="element-9925">
        <div className="flex justify-between items-center" data-id="element-9926">
          <div className="flex items-center" data-id="element-9927">
            <h1 className="text-xl font-bold text-white flex items-center" data-id="element-9928">
              <FileTextIcon size={24} className="mr-2 text-blue-400" data-id="element-9929" />
              Quote Management
            </h1>
          </div>
          <div className="flex items-center space-x-3" data-id="element-9930">
            <div className="relative" data-id="element-9931">
              <button className="p-2 text-blue-300 hover:text-white hover:bg-white/10 rounded-full relative" onClick={() => setShowNotifications(!showNotifications)} data-id="element-9932">
                <BellIcon size={20} data-id="element-9933" />
                {notifications.filter(n => !n.read).length > 0 && <span className="absolute top-0 right-0 w-4 h-4 bg-red-500 text-white text-xs flex items-center justify-center rounded-full" data-id="element-9934">
                    {notifications.filter(n => !n.read).length}
                  </span>}
              </button>
              {showNotifications && <div className="absolute right-0 mt-2 w-80 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg shadow-lg border border-white/10 z-10" data-id="element-9935">
                  <div className="p-3 border-b border-white/10 flex justify-between items-center" data-id="element-9936">
                    <h3 className="font-semibold text-white" data-id="element-9937">Notifications</h3>
                    <button className="text-sm text-blue-400 hover:text-blue-300" onClick={markAllAsRead} data-id="element-9938">
                      Mark all as read
                    </button>
                  </div>
                  <div className="max-h-80 overflow-y-auto" data-id="element-9939">
                    {notifications.length === 0 ? <div className="p-4 text-center text-slate-400" data-id="element-9940">
                        No notifications
                      </div> : notifications.map(notification => {
                  const getTypeStyles = type => {
                    switch (type) {
                      case 'warning':
                        return 'text-amber-400 bg-amber-900/40 border-amber-700/50';
                      case 'success':
                        return 'text-green-400 bg-green-900/40 border-green-700/50';
                      case 'info':
                        return 'text-blue-400 bg-blue-900/40 border-blue-700/50';
                      default:
                        return 'text-blue-400 bg-blue-900/40 border-blue-700/50';
                    }
                  };
                  return <div key={notification.id} className={`p-3 border-b border-white/10 hover:bg-white/5 ${!notification.read ? 'bg-white/5' : ''}`} data-id="element-9941">
                            <div className="flex" data-id="element-9942">
                              <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${getTypeStyles(notification.type)} border`} data-id="element-9943">
                                {notification.type === 'warning' && <ClockIcon size={16} data-id="element-9944" />}
                                {notification.type === 'success' && <CheckCircleIcon size={16} data-id="element-9945" />}
                                {notification.type === 'info' && <InfoIcon size={16} data-id="element-9946" />}
                              </div>
                              <div data-id="element-9947">
                                <h4 className="font-medium text-white" data-id="element-9948">
                                  {notification.title}
                                </h4>
                                <p className="text-sm text-blue-200" data-id="element-9949">
                                  {notification.description}
                                </p>
                                <div className="text-xs text-blue-300 mt-1" data-id="element-9950">
                                  {notification.time}
                                </div>
                              </div>
                            </div>
                          </div>;
                })}
                  </div>
                  <div className="p-3 border-t border-white/10 text-center" data-id="element-9951">
                    <button className="text-sm text-blue-400 hover:text-blue-300" data-id="element-9952">
                      View all notifications
                    </button>
                  </div>
                </div>}
            </div>
            <button className="p-2 text-blue-300 hover:text-white hover:bg-white/10 rounded-full" onClick={() => setDarkMode(!darkMode)} data-id="element-9953">
              {darkMode ? <SunIcon size={20} data-id="element-9954" /> : <MoonIcon size={20} data-id="element-9955" />}
            </button>
            <div className="relative" data-id="element-9956">
              <button className="flex items-center space-x-2 hover:bg-white/10 py-1.5 px-2 rounded-lg" onClick={() => setShowUserMenu(!showUserMenu)} data-id="element-9957">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 text-white rounded-full flex items-center justify-center font-medium" data-id="element-9958">
                  JD
                </div>
                <span className="text-white font-medium hidden md:block" data-id="element-9959">
                  John Doe
                </span>
                <ChevronDownIcon size={16} className="text-blue-300 hidden md:block" data-id="element-9960" />
              </button>
              {showUserMenu && <div className="absolute right-0 mt-2 w-56 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg shadow-lg border border-white/10 z-10" data-id="element-9961">
                  <div className="p-3 border-b border-white/10" data-id="element-9962">
                    <div className="font-medium text-white" data-id="element-9963">John Doe</div>
                    <div className="text-sm text-blue-300" data-id="element-9964">
                      john.doe@example.com
                    </div>
                  </div>
                  <div className="py-1" data-id="element-9965">
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-9966">
                      <UserIcon size={16} className="mr-2 text-blue-400" data-id="element-9967" />
                      My Profile
                    </button>
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-9968">
                      <SettingsIcon size={16} className="mr-2 text-blue-400" data-id="element-9969" />
                      Settings
                    </button>
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-9970">
                      <HelpCircleIcon size={16} className="mr-2 text-blue-400" data-id="element-9971" />
                      Help & Support
                    </button>
                  </div>
                  <div className="py-1 border-t border-white/10" data-id="element-9972">
                    <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-9973">
                      <LogoutIcon size={16} className="mr-2 text-blue-400" data-id="element-9974" />
                      Sign Out
                    </button>
                  </div>
                </div>}
            </div>
          </div>
        </div>
      </div>
      {/* Search and filters */}
      <div className="bg-white/5 backdrop-blur-sm border-b border-white/10 px-6 py-4 relative z-10" data-id="element-9975">
        <div className="flex flex-wrap items-center gap-3" data-id="element-9976">
          <div className="relative flex-1 min-w-[240px]" data-id="element-9977">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-blue-300" size={18} data-id="element-9978" />
            <input type="text" placeholder="Search quotes, customers, products..." value={searchQuery} onChange={handleSearchChange} className="w-full bg-white/10 border border-white/20 rounded-lg pl-10 pr-4 py-2.5 text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-9979" />
          </div>
          <div className="flex items-center gap-2" data-id="element-9980">
            <div className="relative" data-id="element-9981">
              <select className="appearance-none bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" value={dateRange} onChange={e => setDateRange(e.target.value)} data-id="element-9982">
                <option value="all" data-id="element-9983">All Time</option>
                <option value="today" data-id="element-9984">Today</option>
                <option value="week" data-id="element-9985">This Week</option>
                <option value="month" data-id="element-9986">This Month</option>
                <option value="quarter" data-id="element-9987">This Quarter</option>
                <option value="year" data-id="element-9988">This Year</option>
              </select>
              <ChevronDownIcon className="absolute right-3 top-1/2 transform -translate-y-1/2 text-blue-300 pointer-events-none" size={16} data-id="element-9989" />
            </div>
            <button className={`flex items-center ${activeFilterCount > 0 ? 'bg-blue-600 hover:bg-blue-700' : 'bg-white/10 hover:bg-white/15'} border ${activeFilterCount > 0 ? 'border-blue-500' : 'border-white/20'} rounded-lg px-4 py-2.5 text-white transition-colors relative`} onClick={toggleFilterPanel} data-id="element-9990">
              <FilterIcon size={18} className="mr-2" data-id="element-9991" />
              Filters
              {activeFilterCount > 0 && <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-9992">
                  {activeFilterCount}
                </span>}
            </button>
            <button className="flex items-center bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2.5 transition-colors" onClick={onNewQuote} data-id="element-9993">
              <PlusIcon size={18} className="mr-2" data-id="element-9994" />
              New Quote
            </button>
          </div>
        </div>
        {/* Applied filters display */}
        {activeFilterCount > 0 && <div className="mt-3 flex flex-wrap gap-2" data-id="element-9995">
            {appliedFilters.status !== 'all' && <div className="bg-blue-900/40 text-blue-300 border border-blue-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-9996">
                <span className="mr-2" data-id="element-9997">Status: {appliedFilters.status}</span>
                <button onClick={() => removeFilter('status')} className="text-blue-300 hover:text-white" data-id="element-9998">
                  <XIcon size={14} data-id="element-9999" />
                </button>
              </div>}
            {appliedFilters.businessUnitUser && <div className="bg-indigo-900/40 text-indigo-300 border border-indigo-800/50 rounded-full px-3 py-1 text-sm flex items-center cursor-pointer" onClick={openUserModal} data-id="element-10000">
                <span className="mr-2" data-id="element-10001">
                  User: {appliedFilters.businessUnitUser}
                </span>
                <button onClick={e => {
            e.stopPropagation();
            removeFilter('businessUnitUser');
          }} className="text-indigo-300 hover:text-white" data-id="element-10002">
                  <XIcon size={14} data-id="element-10003" />
                </button>
              </div>}
            {appliedFilters.quoteType !== 'all' && <div className="bg-purple-900/40 text-purple-300 border border-purple-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-10004">
                <span className="mr-2" data-id="element-10005">Type: {appliedFilters.quoteType}</span>
                <button onClick={() => removeFilter('quoteType')} className="text-purple-300 hover:text-white" data-id="element-10006">
                  <XIcon size={14} data-id="element-10007" />
                </button>
              </div>}
            {appliedFilters.region !== 'all' && <div className="bg-green-900/40 text-green-300 border border-green-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-10008">
                <span className="mr-2" data-id="element-10009">Region: {appliedFilters.region}</span>
                <button onClick={() => removeFilter('region')} className="text-green-300 hover:text-white" data-id="element-10010">
                  <XIcon size={14} data-id="element-10011" />
                </button>
              </div>}
            {appliedFilters.country !== 'all' && <div className="bg-amber-900/40 text-amber-300 border border-amber-800/50 rounded-full px-3 py-1 text-sm flex items-center" data-id="element-10012">
                <span className="mr-2" data-id="element-10013">Country: {appliedFilters.country}</span>
                <button onClick={() => removeFilter('country')} className="text-amber-300 hover:text-white" data-id="element-10014">
                  <XIcon size={14} data-id="element-10015" />
                </button>
              </div>}
            <button onClick={resetAllFilters} className="bg-white/10 text-blue-200 border border-white/20 rounded-full px-3 py-1 text-sm hover:bg-white/15" data-id="element-10016">
              Clear All
            </button>
          </div>}
      </div>
      {/* Main content with sidebar */}
      <div className="flex-1 flex overflow-hidden relative z-10" data-id="element-10017">
        {/* Filter sidebar */}
        <AnimatePresence data-id="element-10018">
          {showFilterPanel && <motion.div className="w-80 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border-r border-white/10 overflow-y-auto flex-shrink-0" initial={{
          x: -320
        }} animate={{
          x: 0
        }} exit={{
          x: -320
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-10019">
              <div className="p-4 border-b border-white/10 flex justify-between items-center" data-id="element-10020">
                <h3 className="text-lg font-semibold text-white flex items-center" data-id="element-10021">
                  <FilterIcon size={18} className="mr-2 text-blue-400" data-id="element-10022" />
                  Filters
                </h3>
                <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-full p-1.5" onClick={() => setShowFilterPanel(false)} data-id="element-10023">
                  <XIcon size={16} data-id="element-10024" />
                </button>
              </div>
              <div className="p-4 space-y-6" data-id="element-10025">
                {/* Status filter */}
                <div data-id="element-10026">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-10027">
                    Status
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.status} onChange={e => applyFilter('status', e.target.value)} data-id="element-10028">
                    <option value="all" data-id="element-10029">All Statuses</option>
                    <option value="active" data-id="element-10030">Active</option>
                    <option value="pending" data-id="element-10031">Pending</option>
                    <option value="expiring" data-id="element-10032">Expiring Soon</option>
                    <option value="expired" data-id="element-10033">Expired</option>
                    <option value="approved" data-id="element-10034">Approved</option>
                    <option value="lost" data-id="element-10035">Lost</option>
                  </select>
                </div>
                {/* Business Unit User filter */}
                <div data-id="element-10036">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-10037">
                    Business Unit User
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.businessUnitUser || ''} onChange={e => applyFilter('businessUnitUser', e.target.value === 'all' ? null : e.target.value)} data-id="element-10038">
                    <option value="all" data-id="element-10039">All Users</option>
                    {businessUnitUsers.map(user => <option key={user.id} value={user.name} data-id="element-10040">
                        {user.name} - {user.businessUnit}
                      </option>)}
                  </select>
                </div>
                {/* Quote Type filter */}
                <div data-id="element-10041">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-10042">
                    Quote Type
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.quoteType} onChange={e => applyFilter('quoteType', e.target.value)} data-id="element-10043">
                    <option value="all" data-id="element-10044">All Types</option>
                    {tags.map(tag => <option key={tag.id} value={tag.name} data-id="element-10045">
                        {tag.name}
                      </option>)}
                  </select>
                </div>
                {/* Region filter */}
                <div data-id="element-10046">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-10047">
                    Region
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.region} onChange={e => applyFilter('region', e.target.value)} data-id="element-10048">
                    <option value="all" data-id="element-10049">All Regions</option>
                    {/* Get unique regions from quotes */}
                    {[...new Set(quotesList.map(q => q.region))].map(region => <option key={region} value={region} data-id="element-10050">
                          {region}
                        </option>)}
                  </select>
                </div>
                {/* Country filter */}
                <div data-id="element-10051">
                  <label className="block text-sm font-medium text-blue-200 mb-2" data-id="element-10052">
                    Country
                  </label>
                  <select className="w-full bg-white/10 border border-white/20 rounded-lg pl-3 pr-10 py-2.5 text-white appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500" value={appliedFilters.country} onChange={e => applyFilter('country', e.target.value)} data-id="element-10053">
                    <option value="all" data-id="element-10054">All Countries</option>
                    {/* Get unique countries from quotes */}
                    {[...new Set(quotesList.map(q => q.country))].map(country => <option key={country} value={country} data-id="element-10055">
                          {country}
                        </option>)}
                  </select>
                </div>
                <div className="pt-4 border-t border-white/10" data-id="element-10056">
                  <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2.5 rounded-lg transition-colors" onClick={() => setShowFilterPanel(false)} data-id="element-10057">
                    Apply Filters
                  </button>
                  <button className="w-full mt-2 bg-white/10 hover:bg-white/15 text-blue-200 py-2.5 rounded-lg transition-colors" onClick={resetAllFilters} data-id="element-10058">
                    Reset All Filters
                  </button>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
        {/* Main content area */}
        <div className="flex-1 overflow-auto p-6" data-id="element-10059">
          <div className="space-y-6" data-id="element-10060">
            {/* Summary cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-10061">
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-10062">
                <div className="flex items-center justify-between mb-3" data-id="element-10063">
                  <h3 className="text-blue-200 font-medium" data-id="element-10064">Total Quotes</h3>
                  <div className="p-2 bg-blue-900/50 rounded-lg border border-blue-800/50" data-id="element-10065">
                    <ClipboardIcon size={18} className="text-blue-400" data-id="element-10066" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-10067">
                  {quoteStats.total}
                </div>
                <div className="text-sm text-blue-300" data-id="element-10068">
                  <span className="inline-flex items-center text-green-400 mr-1" data-id="element-10069">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-10070" />
                    +12%
                  </span>
                  vs previous month
                </div>
              </div>
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-10071">
                <div className="flex items-center justify-between mb-3" data-id="element-10072">
                  <h3 className="text-blue-200 font-medium" data-id="element-10073">Active Quotes</h3>
                  <div className="p-2 bg-green-900/50 rounded-lg border border-green-800/50" data-id="element-10074">
                    <CheckCircleIcon size={18} className="text-green-400" data-id="element-10075" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-10076">
                  {quoteStats.active}
                </div>
                <div className="text-sm text-blue-300" data-id="element-10077">
                  <span className="inline-flex items-center text-green-400 mr-1" data-id="element-10078">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-10079" />
                    +5%
                  </span>
                  vs previous month
                </div>
              </div>
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-10080">
                <div className="flex items-center justify-between mb-3" data-id="element-10081">
                  <h3 className="text-blue-200 font-medium" data-id="element-10082">Expiring Soon</h3>
                  <div className="p-2 bg-amber-900/50 rounded-lg border border-amber-800/50" data-id="element-10083">
                    <ClockIcon size={18} className="text-amber-400" data-id="element-10084" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-10085">
                  {quoteStats.expiring}
                </div>
                <div className="text-sm text-blue-300" data-id="element-10086">
                  <span className="inline-flex items-center text-amber-400 mr-1" data-id="element-10087">
                    <AlertCircleIcon size={14} className="mr-1" data-id="element-10088" />
                  </span>
                  Require attention
                </div>
              </div>
              <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-10089">
                <div className="flex items-center justify-between mb-3" data-id="element-10090">
                  <h3 className="text-blue-200 font-medium" data-id="element-10091">Total Value</h3>
                  <div className="p-2 bg-blue-900/50 rounded-lg border border-blue-800/50" data-id="element-10092">
                    <DollarSignIcon size={18} className="text-blue-400" data-id="element-10093" />
                  </div>
                </div>
                <div className="text-3xl font-bold text-white mb-1" data-id="element-10094">
                  ${quoteStats.totalValue.toLocaleString()}
                </div>
                <div className="text-sm text-blue-300" data-id="element-10095">
                  <span className="inline-flex items-center text-green-400 mr-1" data-id="element-10096">
                    <TrendingUpIcon size={14} className="mr-1" data-id="element-10097" />
                    +8.5%
                  </span>
                  vs previous month
                </div>
              </div>
            </div>
            {/* Quick access filters */}
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 p-4" data-id="element-10098">
              <div className="flex flex-wrap items-center gap-3" data-id="element-10099">
                <span onClick={() => setQuickFilterActive('all')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'all' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-10100">
                  <FileTextIcon size={14} className="mr-1.5" data-id="element-10101" />
                  All
                </span>
                <span onClick={() => setQuickFilterActive('my-quotes')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'my-quotes' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-10102">
                  <UserIcon size={14} className="mr-1.5" data-id="element-10103" />
                  My Quotes
                </span>
                <span onClick={() => setQuickFilterActive('dealer-quotes')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'dealer-quotes' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-10104">
                  <BuildingIcon size={14} className="mr-1.5" data-id="element-10105" />
                  My Dealers' Quotes
                </span>
                <span onClick={() => setQuickFilterActive('expiring-soon')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'expiring-soon' ? 'bg-amber-500/70 text-white ring-2 ring-amber-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-10106">
                  <AlertCircleIcon size={14} className="mr-1.5" data-id="element-10107" />
                  Expiring Soon
                </span>
                <span onClick={() => setQuickFilterActive('expired')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'expired' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-10108">
                  <XCircleIcon size={14} className="mr-1.5" data-id="element-10109" />
                  Expired
                </span>
                <span onClick={() => setQuickFilterActive('won-lost')} className={`px-3 py-1.5 rounded-full flex items-center text-sm cursor-pointer transition-colors ${quickFilterActive === 'won-lost' ? 'bg-blue-500/70 text-white ring-2 ring-blue-500 ring-opacity-50' : 'bg-white/10 text-blue-200 hover:bg-white/15 border border-white/20'}`} data-id="element-10110">
                  <CheckCircleIcon size={14} className="mr-1.5" data-id="element-10111" />
                  Won / Lost
                </span>
                <div className="flex items-center ml-auto gap-2" data-id="element-10112">
                  <div className="flex bg-white/10 border border-white/20 rounded-lg overflow-hidden p-0.5" data-id="element-10113">
                    <button className={`p-1.5 rounded-md ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-white/10'}`} onClick={() => setViewMode('list')} data-id="element-10114">
                      <ListIcon size={18} data-id="element-10115" />
                    </button>
                    <button className={`p-1.5 rounded-md ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-white/10'}`} onClick={() => setViewMode('grid')} data-id="element-10116">
                      <LayoutGridIcon size={18} data-id="element-10117" />
                    </button>
                    <button className={`p-1.5 rounded-md ${viewMode === 'kanban' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-white/10'}`} onClick={() => setViewMode('kanban')} data-id="element-10118">
                      <KanbanIcon size={18} data-id="element-10119" />
                    </button>
                  </div>
                  <div className="relative" data-id="element-10120">
                    <button className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-blue-200 flex items-center" onClick={() => setShowSortMenu(!showSortMenu)} data-id="element-10121">
                      <ArrowUpDownIcon size={16} className="text-blue-300 mr-2" data-id="element-10122" />
                      <span data-id="element-10123">Sort by</span>
                      <ChevronDownIcon size={16} className="text-blue-300 ml-2" data-id="element-10124" />
                    </button>
                    {showSortMenu && <div className="absolute right-0 mt-2 w-48 bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg shadow-lg border border-white/10 z-10 py-1" data-id="element-10125">
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-10126">
                          <CalendarIcon size={14} className="mr-2 text-blue-300" data-id="element-10127" />
                          Most recent
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-10128">
                          <CalendarIcon size={14} className="mr-2 text-blue-300" data-id="element-10129" />
                          Oldest first
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-10130">
                          <ArrowUpIcon size={14} className="mr-2 text-blue-300" data-id="element-10131" />
                          Highest value
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-10132">
                          <ArrowDownIcon size={14} className="mr-2 text-blue-300" data-id="element-10133" />
                          Lowest value
                        </button>
                        <button className="flex w-full items-center px-4 py-2 text-blue-200 hover:bg-white/10" data-id="element-10134">
                          <StarIcon size={14} className="mr-2 text-blue-300" data-id="element-10135" />
                          Highest score
                        </button>
                      </div>}
                  </div>
                </div>
              </div>
            </div>
            {/* Quotes list */}
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl shadow-lg border border-white/10 overflow-hidden" data-id="element-10136">
              <div className="p-4 border-b border-white/10 flex justify-between items-center" data-id="element-10137">
                <h3 className="font-semibold text-white flex items-center" data-id="element-10138">
                  <FileTextIcon size={18} className="mr-2 text-blue-400" data-id="element-10139" />
                  {quickFilterActive === 'my-quotes' ? 'My Quotes' : quickFilterActive === 'dealer-quotes' ? "My Dealers' Quotes" : quickFilterActive === 'expired' ? 'Expired Quotes' : quickFilterActive === 'expiring-soon' ? 'Expiring Soon Quotes' : quickFilterActive === 'won-lost' ? 'Won/Lost Quotes' : 'All Quotes'}
                  {appliedFilters.businessUnitUser && <span className="ml-2 text-blue-300" data-id="element-10140">
                      • {appliedFilters.businessUnitUser}
                    </span>}
                </h3>
                <div className="flex items-center gap-2" data-id="element-10141">
                  <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg p-2" data-id="element-10142">
                    <DownloadIcon size={16} data-id="element-10143" />
                  </button>
                  <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg p-2" data-id="element-10144">
                    <PrinterIcon size={16} data-id="element-10145" />
                  </button>
                  <button className="text-blue-300 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg p-2" data-id="element-10146">
                    <RefreshCwIcon size={16} data-id="element-10147" />
                  </button>
                </div>
              </div>
              {viewMode === 'list' && <div className="divide-y divide-white/10" data-id="element-10148">
                  {filteredQuotes.map((quote, index) => <div key={index} className="p-4 hover:bg-white/5 transition-colors cursor-pointer" onClick={() => onViewQuote({
                id: quote.id
              })} data-id="element-10149">
                      <div className="flex justify-between items-start" data-id="element-10150">
                        <div className="flex items-start" data-id="element-10151">
                          <div className="mr-3 mt-0.5" data-id="element-10152">
                            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center" data-id="element-10153">
                              <FileTextIcon size={20} className="text-blue-400" data-id="element-10154" />
                            </div>
                          </div>
                          <div data-id="element-10155">
                            <div className="flex items-center" data-id="element-10156">
                              <h4 className="font-medium text-white" data-id="element-10157">
                                {quote.id}
                              </h4>
                              <button className="ml-2 text-blue-300 hover:text-amber-400" onClick={e => {
                          e.stopPropagation();
                          toggleFavorite(quote.id);
                        }} data-id="element-10158">
                                {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={14} className="fill-amber-500 text-amber-500" data-id="element-10159" /> : <BookmarkIcon size={14} data-id="element-10160" />}
                              </button>
                              {quote.score && <div className={`ml-3 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                          e.stopPropagation();
                          openScoreModal(quote.id, e);
                        }} data-id="element-10161">
                                  <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10162" />
                                  <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10163">
                                    {quote.score}
                                  </span>
                                </div>}
                            </div>
                            <div className="text-sm text-blue-200 mt-0.5" data-id="element-10164">
                              {quote.title}
                            </div>
                            <div className="text-xs text-blue-300 mt-1" data-id="element-10165">
                              <span className="flex items-center" data-id="element-10166">
                                <BuildingIcon size={12} className="mr-1" data-id="element-10167" />
                                {quote.company}
                              </span>
                            </div>
                            <div className="flex items-center mt-2 flex-wrap gap-y-1 gap-x-2" data-id="element-10168">
                              <span className={`text-xs ${getStatusBadge(quote.status).bg} ${getStatusBadge(quote.status).text} border ${quote.status === 'active' ? 'border-green-800' : quote.status === 'pending' ? 'border-amber-800' : quote.status === 'expired' ? 'border-red-800' : 'border-white/20'} px-2 py-0.5 rounded-full flex items-center`} data-id="element-10169">
                                {getStatusBadge(quote.status).icon}
                                {quote.status}
                              </span>
                              {quote.tags.map((tag, tagIndex) => {
                          const tagInfo = tags.find(t => t.name === tag);
                          const tagColor = tagInfo ? getTagColor(tagInfo.color) : getTagColor('gray');
                          return <span key={tagIndex} className={`text-xs ${tagColor.bg} ${tagColor.text} ${tagColor.border} px-2 py-0.5 rounded-full`} data-id="element-10170">
                                    {tag}
                                  </span>;
                        })}
                              {quote.businessUnitUser && <span className="text-xs bg-indigo-100 dark:bg-indigo-900/40 text-indigo-800 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800 px-2 py-0.5 rounded-full flex items-center cursor-pointer" onClick={e => {
                          e.stopPropagation();
                          const user = businessUnitUsers.find(u => u.name === quote.businessUnitUser);
                          if (user) {
                            setSelectedBusinessUnitUser(user);
                            setShowUserModal(true);
                          }
                        }} data-id="element-10171">
                                  <UserIcon size={10} className="mr-1" data-id="element-10172" />
                                  {quote.businessUnitUser}
                                </span>}
                            </div>
                          </div>
                        </div>
                        <div className="text-right" data-id="element-10173">
                          <div className="font-semibold text-white" data-id="element-10174">
                            {quote.amount}
                          </div>
                          <div className="text-xs text-blue-300 mt-1 flex items-center justify-end" data-id="element-10175">
                            <CalendarIcon size={12} className="mr-1" data-id="element-10176" />
                            Created {quote.date}
                          </div>
                          <div className="text-xs text-blue-300 mt-1" data-id="element-10177">
                            {quote.status !== 'approved' && quote.status !== 'expired' ? `Expires in ${quote.expiresIn}` : quote.expiresIn}
                          </div>
                          <div className="mt-2 flex space-x-2 justify-end" data-id="element-10178">
                            <button className="text-blue-200 hover:text-white text-sm font-medium bg-white/10 hover:bg-white/15 rounded-lg px-3 py-1 flex items-center" data-id="element-10179">
                              <EyeIcon size={14} className="mr-1.5" data-id="element-10180" />
                              View
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>}
              {viewMode === 'grid' && <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4" data-id="element-10181">
                  {filteredQuotes.map((quote, index) => <div key={index} className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden hover:border-blue-500/30 transition-all cursor-pointer shadow-lg" onClick={() => onViewQuote({
                id: quote.id
              })} data-id="element-10182">
                      <div className="p-4" data-id="element-10183">
                        <div className="flex justify-between items-start mb-3" data-id="element-10184">
                          <div className="flex items-center" data-id="element-10185">
                            <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center mr-2" data-id="element-10186">
                              <FileTextIcon size={16} className="text-blue-400" data-id="element-10187" />
                            </div>
                            <h4 className="font-medium text-white" data-id="element-10188">
                              {quote.id}
                            </h4>
                          </div>
                          <div className="flex items-center" data-id="element-10189">
                            {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                        e.stopPropagation();
                        openScoreModal(quote.id, e);
                      }} data-id="element-10190">
                                <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10191" />
                                <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10192">
                                  {quote.score}
                                </span>
                              </div>}
                            <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                        e.stopPropagation();
                        toggleFavorite(quote.id);
                      }} data-id="element-10193">
                              {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-10194" /> : <BookmarkIcon size={12} data-id="element-10195" />}
                            </button>
                          </div>
                        </div>
                        <div className="text-sm text-blue-200 mb-2" data-id="element-10196">
                          {quote.title}
                        </div>
                        <div className="text-xs text-blue-300 mb-2" data-id="element-10197">
                          <span className="flex items-center" data-id="element-10198">
                            <BuildingIcon size={12} className="mr-1" data-id="element-10199" />
                            {quote.company}
                          </span>
                        </div>
                        <div className="flex flex-wrap gap-1 mb-3" data-id="element-10200">
                          {quote.tags.map((tag, tagIndex) => {
                      const tagInfo = tags.find(t => t.name === tag);
                      const tagColor = tagInfo ? getTagColor(tagInfo.color) : getTagColor('gray');
                      return <span key={tagIndex} className={`text-xs ${tagColor.bg} ${tagColor.text} ${tagColor.border} px-2 py-0.5 rounded-full`} data-id="element-10201">
                                {tag}
                              </span>;
                    })}
                          {quote.businessUnitUser && <span className="text-xs bg-indigo-100 dark:bg-indigo-900/40 text-indigo-800 dark:text-indigo-300 border border-indigo-200 dark:border-indigo-800 px-2 py-0.5 rounded-full flex items-center cursor-pointer" onClick={e => {
                      e.stopPropagation();
                      const user = businessUnitUsers.find(u => u.name === quote.businessUnitUser);
                      if (user) {
                        setSelectedBusinessUnitUser(user);
                        setShowUserModal(true);
                      }
                    }} data-id="element-10202">
                              <UserIcon size={10} className="mr-1" data-id="element-10203" />
                              {quote.businessUnitUser}
                            </span>}
                        </div>
                        <div className="flex justify-between items-end" data-id="element-10204">
                          <span className={`text-xs ${getStatusBadge(quote.status).bg} ${getStatusBadge(quote.status).text} border ${quote.status === 'active' ? 'border-green-800' : quote.status === 'pending' ? 'border-amber-800' : quote.status === 'expired' ? 'border-red-800' : 'border-white/20'} px-2 py-0.5 rounded-full flex items-center`} data-id="element-10205">
                            {getStatusBadge(quote.status).icon}
                            {quote.status}
                          </span>
                          <div className="font-semibold text-white" data-id="element-10206">
                            {quote.amount}
                          </div>
                        </div>
                      </div>
                      <div className="bg-white/5 p-3 border-t border-white/10 flex justify-between items-center" data-id="element-10207">
                        <div className="text-xs text-blue-300 flex items-center" data-id="element-10208">
                          <CalendarIcon size={12} className="mr-1" data-id="element-10209" />
                          {quote.date}
                        </div>
                        <div className="text-xs text-blue-300" data-id="element-10210">
                          {quote.status !== 'approved' && quote.status !== 'expired' ? `Expires in ${quote.expiresIn}` : quote.expiresIn}
                        </div>
                      </div>
                    </div>)}
                </div>}
              {viewMode === 'kanban' && <div className="p-4 overflow-x-auto" data-id="element-10211">
                  <div className="flex gap-4 min-w-[800px]" data-id="element-10212">
                    {/* Activas */}
                    <div className="flex-1 min-w-[250px]" data-id="element-10213">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-10214">
                        <h4 className="text-white font-medium flex items-center" data-id="element-10215">
                          <CheckCircleIcon size={16} className="text-green-400 mr-2" data-id="element-10216" />
                          Active (
                          {filteredQuotes.filter(q => q.status === 'active').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-10217">
                        {filteredQuotes.filter(q => q.status === 'active').map((quote, index) => <div key={index} className="bg-gradient-to-r from-emerald-500/10 to-teal-500/10 border border-emerald-500/20 rounded-lg p-3 hover:border-emerald-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-10218">
                              <div className="flex justify-between items-start mb-2" data-id="element-10219">
                                <h5 className="text-white font-medium" data-id="element-10220">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-10221">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-10222">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10223" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10224">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-10225">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-10226" /> : <BookmarkIcon size={12} data-id="element-10227" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-10228">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-10229">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-10230">
                                <div className="text-xs text-blue-300" data-id="element-10231">
                                  Expires in {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-10232">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Pendientes */}
                    <div className="flex-1 min-w-[250px]" data-id="element-10233">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-10234">
                        <h4 className="text-white font-medium flex items-center" data-id="element-10235">
                          <ClockIcon size={16} className="text-amber-400 mr-2" data-id="element-10236" />
                          Pending (
                          {filteredQuotes.filter(q => q.status === 'pending').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-10237">
                        {filteredQuotes.filter(q => q.status === 'pending').map((quote, index) => <div key={index} className="bg-gradient-to-r from-blue-500/10 to-indigo-500/10 border border-blue-500/20 rounded-lg p-3 hover:border-blue-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-10238">
                              <div className="flex justify-between items-start mb-2" data-id="element-10239">
                                <h5 className="text-white font-medium" data-id="element-10240">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-10241">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-10242">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10243" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10244">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-10245">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-10246" /> : <BookmarkIcon size={12} data-id="element-10247" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-10248">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-10249">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-10250">
                                <div className="text-xs text-blue-300" data-id="element-10251">
                                  Expires in {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-10252">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Por expirar */}
                    <div className="flex-1 min-w-[250px]" data-id="element-10253">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-10254">
                        <h4 className="text-white font-medium flex items-center" data-id="element-10255">
                          <AlarmClockIcon size={16} className="text-amber-400 mr-2" data-id="element-10256" />
                          Expiring Soon (
                          {filteredQuotes.filter(q => q.status === 'expiring').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-10257">
                        {filteredQuotes.filter(q => q.status === 'expiring').map((quote, index) => <div key={index} className="bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20 rounded-lg p-3 hover:border-amber-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-10258">
                              <div className="flex justify-between items-start mb-2" data-id="element-10259">
                                <h5 className="text-white font-medium" data-id="element-10260">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-10261">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-10262">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10263" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10264">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-10265">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-10266" /> : <BookmarkIcon size={12} data-id="element-10267" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-10268">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-10269">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-10270">
                                <div className="text-xs text-blue-300" data-id="element-10271">
                                  Expires in {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-10272">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Aprobadas/Finalizadas */}
                    <div className="flex-1 min-w-[250px]" data-id="element-10273">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-10274">
                        <h4 className="text-white font-medium flex items-center" data-id="element-10275">
                          <CheckIcon size={16} className="text-blue-400 mr-2" data-id="element-10276" />
                          Approved (
                          {filteredQuotes.filter(q => q.status === 'approved').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-10277">
                        {filteredQuotes.filter(q => q.status === 'approved').map((quote, index) => <div key={index} className="bg-gradient-to-r from-blue-500/10 to-indigo-500/10 border border-blue-500/20 rounded-lg p-3 hover:border-blue-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-10278">
                              <div className="flex justify-between items-start mb-2" data-id="element-10279">
                                <h5 className="text-white font-medium" data-id="element-10280">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-10281">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-10282">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10283" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10284">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-10285">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-10286" /> : <BookmarkIcon size={12} data-id="element-10287" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-10288">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-10289">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-10290">
                                <div className="text-xs text-blue-300" data-id="element-10291">
                                  {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-10292">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                    {/* Expiradas */}
                    <div className="flex-1 min-w-[250px]" data-id="element-10293">
                      <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-lg p-3 mb-3 border border-white/10" data-id="element-10294">
                        <h4 className="text-white font-medium flex items-center" data-id="element-10295">
                          <XCircleIcon size={16} className="text-red-400 mr-2" data-id="element-10296" />
                          Expired (
                          {filteredQuotes.filter(q => q.status === 'expired').length}
                          )
                        </h4>
                      </div>
                      <div className="space-y-3" data-id="element-10297">
                        {filteredQuotes.filter(q => q.status === 'expired').map((quote, index) => <div key={index} className="bg-gradient-to-r from-red-500/10 to-rose-500/10 border border-red-500/20 rounded-lg p-3 hover:border-red-500/40 transition-all cursor-pointer shadow-md" onClick={() => onViewQuote({
                      id: quote.id
                    })} data-id="element-10298">
                              <div className="flex justify-between items-start mb-2" data-id="element-10299">
                                <h5 className="text-white font-medium" data-id="element-10300">
                                  {quote.id}
                                </h5>
                                <div className="flex items-center" data-id="element-10301">
                                  {quote.score && <div className={`mr-2 text-xs px-2 py-0.5 rounded-full inline-flex items-center ${getScoreBgColor(quote.score)} cursor-pointer`} onClick={e => {
                            e.stopPropagation();
                            openScoreModal(quote.id, e);
                          }} data-id="element-10302">
                                      <StarIcon size={12} className={`mr-1 ${getScoreColor(quote.score)}`} data-id="element-10303" />
                                      <span className={`font-medium ${getScoreColor(quote.score)}`} data-id="element-10304">
                                        {quote.score}
                                      </span>
                                    </div>}
                                  <button className="text-blue-300 hover:text-amber-400" onClick={e => {
                            e.stopPropagation();
                            toggleFavorite(quote.id);
                          }} data-id="element-10305">
                                    {favoriteQuotes.includes(quote.id) ? <BookmarkIcon size={12} className="fill-amber-500 text-amber-500" data-id="element-10306" /> : <BookmarkIcon size={12} data-id="element-10307" />}
                                  </button>
                                </div>
                              </div>
                              <div className="text-sm text-blue-200 mb-2" data-id="element-10308">
                                {quote.title}
                              </div>
                              <div className="text-xs text-blue-300 mb-2" data-id="element-10309">
                                {quote.company}
                              </div>
                              <div className="flex justify-between items-center" data-id="element-10310">
                                <div className="text-xs text-red-400" data-id="element-10311">
                                  {quote.expiresIn}
                                </div>
                                <div className="font-medium text-white" data-id="element-10312">
                                  {quote.amount}
                                </div>
                              </div>
                            </div>)}
                      </div>
                    </div>
                  </div>
                </div>}
              {/* Pagination */}
              <div className="p-4 border-t border-white/10 flex justify-between items-center" data-id="element-10313">
                <div className="text-sm text-blue-300" data-id="element-10314">
                  Showing{' '}
                  <span className="font-medium text-white" data-id="element-10315">
                    {filteredQuotes.length}
                  </span>{' '}
                  quotes
                </div>
                <div className="flex items-center space-x-1" data-id="element-10316">
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-10317">
                    Previous
                  </button>
                  <button className="px-3 py-1.5 text-white bg-blue-600 rounded-lg" data-id="element-10318">
                    1
                  </button>
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-10319">
                    2
                  </button>
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-10320">
                    3
                  </button>
                  <button className="px-3 py-1.5 text-blue-200 hover:text-white bg-white/10 hover:bg-white/15 rounded-lg" data-id="element-10321">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Quote Score Modal */}
      {showScoreModal && selectedScore && <QuoteScoreModal quote={quotesList.find(q => q.id === selectedScore)} onClose={() => setShowScoreModal(false)} onUpdate={(quoteId, scoreDetails) => {
      // Actualizar la puntuación en la cotización seleccionada
      const updatedQuotes = quotesList.map(q => q.id === quoteId ? {
        ...q,
        scoreDetails,
        score: scoreDetails.totalScore
      } : q);
      // Aquí debería actualizar el estado de las cotizaciones
      // setQuotes(updatedQuotes);
    }} data-id="element-10322" />}
      {/* Business Unit User Modal */}
      {showUserModal && selectedBusinessUnitUser && <BusinessUnitUserModal user={selectedBusinessUnitUser} onClose={() => setShowUserModal(false)} data-id="element-10323" />}
    </div>;
}
// LogoutIcon component for the user menu
function LogoutIcon({
  size,
  className
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-10324">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-10325" />
      <polyline points="16 17 21 12 16 7" data-id="element-10326" />
      <line x1="21" y1="12" x2="9" y2="12" data-id="element-10327" />
    </svg>;
}